/**
 * Query keys.
 */
export enum QueryKeys {
    QuestionnaireCurrent = "questionnaireCurrent",
    QuestionnaireInstanceCurrent = "questionnaireInstanceList",
    QuestionnaireAssociationList = "questionnaireAssociationList",
    QuestionnaireList = "questionnaireList",
}

export enum DefaultKeys {
    NEW_QUESTIONNAIRE_ID = "newQuestionnaireId",
}